import {all} from "redux-saga/effects";
import rootSettingsSaga from './settings-sagas';
import rootTermsSaga from './term-sagas';
import rootCodesSaga from './code-sagas';
import rootWorktagsSaga from './worktag-sagas';
import rootApiKeySaga from './api-key-sagas';

function* rootSaga() {
    yield all([
        rootSettingsSaga(),
        rootTermsSaga(),
        rootCodesSaga(),
        rootWorktagsSaga(),
        rootApiKeySaga()
    ]);
}

export default rootSaga;